import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { FullscreenTakeover } from "@jsq/ds/core";
import { Column } from "@jsq/ds/layouts";
import ProfileMethodSelector from "~/pages/Compliance/profile/ProfileCreator/ProfileMethodSelector";

const SelectCreateMethodForm = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();

  const basePath = match.url.replace(/\/method\/?$/, "");
  const accountTypePath = basePath.replace(/\/(individual|entity)$/, "");

  const onBack = () => {
    history.push({ pathname: accountTypePath || basePath, search: location.search });
  };

  const onSelectManual = () => {
    history.push({ pathname: basePath, search: location.search });
  };

  const onSelectExtraction = () => {
    history.push({ pathname: `${basePath}/extraction`, search: location.search });
  };

  return (
    <FullscreenTakeover.Body>
      <Column size="lg">
        <ProfileMethodSelector
          title="Add owner or controller"
          backLabel="Account type"
          onBack={onBack}
          onSelectManual={onSelectManual}
          onSelectExtraction={onSelectExtraction}
        />
      </Column>
    </FullscreenTakeover.Body>
  );
};

export default SelectCreateMethodForm;
